<template>
<div v-if="!isLoading" class="guide">
  <div class="guide-header">
    <div class="item"><h1>Non-Traditional Feeding Toolkit</h1></div>
    <div class="item">
      <a href="./downloads/product guides/mpk-ntf-toolkit.pdf" download
        ><h2>Download as PDF</h2></a
      >
    </div>
  </div>
  <br>
  <div v-if="ntfToolkitData" class="product-tables">
    <NTFToolkitTable :columns="this.headers" :rows="bowlItems" title="Bowls" />
    <br />
    <NTFToolkitTable :columns="headers" :rows="breadItems" title="Breads" />
    <br />
    <NTFToolkitTable
      :columns="headers"
      :rows="breakfastItems"
      title="Breakfasts"
    />
    <br />
    <NTFToolkitTable :columns="headers" :rows="pizzaItems" title="Pizzas" />
    <br />
    <NTFToolkitTable :columns="headers" :rows="pouchItems" title="Pouches" />
    <br />
    <NTFToolkitTable
      :columns="headers"
      :rows="sandwichItems"
      title="Sandwiches"
    />
    <br />
    <NTFToolkitTable :columns="headers" :rows="trayItems" title="Trays" />
    <br />
  </div>
</div>
</template>

<script>
import NTFToolkitTable from "../components/NTFToolkitTable.vue";
import axios from "axios";

export default {
  name: "NTFToolkit",
  data() {
    return {
      ntfToolkitData: [{}],
      isLoading: true,
      headers: [
        "Manufacturer",
        "Product Image",
        "Description",
        "Mfg Code",
        "Pack Size",
        "MMA",
        "Grain",
        "Clems Code",
        "GFS Code",
        ],
      bowlItems: [{}],
      breadItems: [{}],
      breakfastItems: [{}],
      pizzaItems: [{}],
      pouchItems: [{}],
      sandwichItems: [{}],
      trayItems: [{}],
    };
  },
  mounted() {
    this.getNTFToolkitData();
  },
  methods: {
    getNTFToolkitData() {
      this.isLoading = true;
      axios
        .get(process.env.VUE_APP_URL + "products/GetNTFToolkit")
        .then((response) => {
          this.ntfToolkitData = response.data;//JSON.parse(response.data);
          this.generateSectionLists();
          this.isLoading = false;
        });
    },
    generateSectionLists() {
      this.bowlItems = this.processItems(
        this.ntfToolkitData.filter((item) => item.Section == "Bowls")
      );
      this.breadItems = this.processItems(
        this.ntfToolkitData.filter((item) => item.Section == "Breads")
      );
      this.breakfastItems = this.processItems(
        this.ntfToolkitData.filter((item) => item.Section == "Breakfasts")
      );
      this.pizzaItems = this.processItems(
        this.ntfToolkitData.filter((item) => item.Section == "Pizzas")
      );
      this.pouchItems = this.processItems(
        this.ntfToolkitData.filter((item) => item.Section == "Pouches")
      );
      this.sandwichItems = this.processItems(
        this.ntfToolkitData.filter((item) => item.Section == "Sandwiches")
      );
      this.trayItems = this.processItems(
        this.ntfToolkitData.filter((item) => item.Section == "Trays")
      );
    },
    processItems(items) {
      var processedItems = items.map((item) => {
        return {
          mfgImageHTML: item.MfgImgHTML,
          imageHTML: item.ImageHTML,
          pdfHTML: item.PdfHTML,
          mfgCode: item.MfgCode,
          packSize: item.PackSize,
          mma: item.MMA,
          grain: item.Grain,
          clemsStockCode: item.ClemsStockCode,
          gfsStockCode: item.GFSStockCode,
        };
      });

      return processedItems;
    },
  },
  components: {
    NTFToolkitTable,
  },
};
</script>

<style scoped>
.guide-header {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.item {
  flex: 1 1 auto;
  font-weight: bold;
}
.product-tables {
  max-width: 100vw;
  overflow-x: auto;
}
</style>
